var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('add-new-affiliate-popup', {
    attrs: {
      "show": _vm.isNewAffiliatePopupDisplayed,
      "loading": _vm.waitingForNewAffiliate
    },
    on: {
      "close": function ($event) {
        _vm.isNewAffiliatePopupDisplayed = false;
      },
      "newAffiliate": function (structureName) {
        _vm.createNewAffiliate(structureName);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "Group189"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex flex-col mt-16 mb-16"
  }, [_c('div', {
    staticClass: "-my-2 py-2"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('h3', {
    staticClass: "mt-15 mb-10 lg:mb-15 w-full"
  }, [_vm._v("Affiliations")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-10 justify-center text-center text-gray-600 cursor-pointer"
  }, [_c('div', {
    staticClass: "transform hover:scale-110 transition-transform duration-300 text-2xl hover:text-pink-600 font-light",
    class: {
      'text-indigo-600': _vm.tabDisplay === 'neopass'
    },
    on: {
      "click": function ($event) {
        _vm.tabDisplay = 'neopass';
      }
    }
  }, [_vm._v("\n              Structures Neopass\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "transform hover:scale-110 transition-transform duration-300 text-2xl hover:text-pink-600 font-light",
    class: {
      'text-indigo-600': _vm.tabDisplay === 'noSub'
    },
    on: {
      "click": function ($event) {
        _vm.tabDisplay = 'noSub';
      }
    }
  }, [_vm._v("\n              Structures non inscrites\n            ")])]), _vm._v(" "), _vm.tabDisplay === 'neopass' ? _c('div', [_vm._m(1), _vm._v(" "), _vm.isLoading ? _c('div', {
    staticClass: "flex items-center justify-center w-full"
  }, [_c('span', {
    staticClass: "w-5 h-5 rounded-full border-t-2 border-r animate-spin border-gray-600"
  })]) : _vm._e(), _vm._v(" "), _vm._l(_vm.listStructures, function (structure, idStru) {
    var _structure$admin, _structure$admin2, _structure$admin3;
    return _c('div', {
      key: idStru,
      staticClass: "h-16 lg:h-24 2xl:h-32 text-base bg-gray-100 even:bg-opacity-50 grid grid-cols-6 gap-x-4 place-content-center items-center"
    }, [_c('div', {
      staticClass: "ml-15 col-span-2"
    }, [_vm._v("\n                " + _vm._s(structure === null || structure === void 0 ? void 0 : (_structure$admin = structure.admin) === null || _structure$admin === void 0 ? void 0 : _structure$admin.firstname) + "\n                " + _vm._s(structure === null || structure === void 0 ? void 0 : (_structure$admin2 = structure.admin) === null || _structure$admin2 === void 0 ? void 0 : _structure$admin2.lastname) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2"
    }, [_vm._v("\n                " + _vm._s(structure === null || structure === void 0 ? void 0 : structure.name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2"
    }, [_vm._v("\n                " + _vm._s(structure === null || structure === void 0 ? void 0 : (_structure$admin3 = structure.admin) === null || _structure$admin3 === void 0 ? void 0 : _structure$admin3.affiliate_count) + "\n              ")])]);
  })], 2) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'noSub' ? _c('div', [_c('add-button', {
    staticClass: "m-10 w-max",
    attrs: {
      "libelle": "Ajouter un lien affilié"
    },
    on: {
      "add": function ($event) {
        return _vm.displayNewAffiliatePopup();
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l(_vm.affiliates, function (structure, idStru) {
    return _c('div', {
      key: idStru,
      staticClass: "h-16 lg:h-24 2xl:h-32 text-base bg-gray-100 even:bg-opacity-50 grid grid-cols-12 gap-x-4 place-content-center items-center"
    }, [_c('div', {
      staticClass: "ml-15 col-span-2"
    }, [_vm._v("\n                " + _vm._s(structure.name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-5"
    }, [_vm._v("\n                " + _vm._s(_vm.baseUrl + '?affiliate=' + structure.code) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 relative"
    }, [_c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-indigo-600",
        "libelle": "Copier",
        "icon": "copy"
      },
      on: {
        "clickAction": function ($event) {
          return _vm.copyAffiliateLink(_vm.baseUrl + '?affiliate=' + structure.code, idStru);
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "duration-300",
        "enter-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "duration-300",
        "leave-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }
    }, [_vm.linkCopied === idStru ? _c('tag', {
      staticClass: "absolute right-5 bottom-10",
      attrs: {
        "libelle": "lien copié",
        "text-size": "text-sm",
        "text-font": "font-light"
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-2"
    }, [_vm._v("\n                " + _vm._s(structure === null || structure === void 0 ? void 0 : structure.affiliate_count) + "\n              ")])]);
  })], 2) : _vm._e()])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("Liste des affiliations")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._v("\n        Attribuer un lien d'affiliation aux structures inscrites sur le\n        Neopass ou des structures non inscrites qui veulent affiliés d'autres\n        structures.\n      ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-6 gap-x-4 place-content-center mt-10"
  }, [_c('div', {
    staticClass: "ml-15 col-span-2"
  }, [_vm._v("Utilisateur")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("Structure")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("Nombre d'affiliations")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center"
  }, [_c('div', {
    staticClass: "ml-15 col-span-2"
  }, [_vm._v("Structure")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-5"
  }, [_vm._v("Lien d'affiliation")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("Copier le lien")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("Nombre d'affiliations")])]);

}]

export { render, staticRenderFns }